export { CompleteAccountController as CompleteAccount, useCompleteAccountModal } from './complete-account-controller';
